import { ThemeProvider, UiLoggerProvider } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { getUiLogger, setupLogger } from '@/lib/logger'
import { useDevtoolsStore } from '@/stores/devtools'
import { router } from './router'
import '../styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
})

function Devtools() {
  const { showQueryDevtools, showRouterDevtools } = useDevtoolsStore()

  return (
    <>
      {showQueryDevtools && <ReactQueryDevtools client={queryClient} initialIsOpen={false} />}
      {showRouterDevtools && <TanStackRouterDevtools router={router} initialIsOpen={false} />}
    </>
  )
}

setupLogger()

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('root')
  if (!root) throw new Error('Root element not found')

  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <UiLoggerProvider value={getUiLogger}>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
          {import.meta.env.DEV && <Devtools />}
        </UiLoggerProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
})
